<template>
    <div class="card">
    <TabView>
        <TabPanel header="ข้อมูลระดับสิทธิ์" v-if="checkPermission()">
            <admin-permission></admin-permission>
        </TabPanel>
        <TabPanel header="ข้อมูลผู้ใช้งานระบบ">
            <admin-user></admin-user>
        </TabPanel>
        <!-- <TabPanel header="ข้อมูลเมนูการใช้งาน">
            <admin-menu></admin-menu>
        </TabPanel> -->
        
        <!-- <TabPanel header="Configuration" v-if="checkPermission()">
            <admin-config></admin-config>
        </TabPanel> -->
        
    </TabView>
    </div>
</template>

<script>
import adminPermission from './InformationPermissionLevel';
import adminUser from './InformationSystemUser';
// import adminMenu from './InformationUsageMenu';
// import adminConfig from './InformationConfiguration';

export default {
    components: {
        adminPermission,
        adminUser,
        //adminMenu,
        // adminConfig   
    },
    data() {
      return{
      }    
    },
    created(){
    },

    mounted(){

    },

    watch:{
       
    },
    computed: {

    }
}
</script>